/* eslint-disable import/prefer-default-export */
const LOCALSTORAGE_TOKEN = 'admin:token';

export { LOCALSTORAGE_TOKEN };
